export default __webpack_public_path__ + "static/media/image7.53f1b1c8.jpg";